<template>
  <el-dialog class="air-modal" :title="title" :visible.sync="showDialog" :close-on-click-modal="false" width="420px" append-to-body v-dialog-drag>
    <div class="air-modal-body flex vertical acenter">
      <img src="@/air/assets/img/icon/warning-big.png" />
      <div class="confirm-content" v-html="content"></div>
    </div>
    <div slot="footer" class="air-modal-footer flex jend acenter">
      <el-button type="text" class="text-button-cancel" @click="cancel">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="confirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'airConfirm',
  props: {
    title: {
      type: String,
      default: '提示'
    },
    content: {
      type: String,
      default: '确认操作？'
    },
    show: {
      type: Boolean,
      default: false
    },
    confirmFunction: {
      type: Function,
      default () {
        return () => {
          console.log('confirm')
        }
      }
    }
  },
  data() {
    return {
      submitLoading: false
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.show;
      },
      set(newValue) {
        this.$emit("update:show", newValue);
      }
    },
  },
  watch: {
    showDialog(newVal) {
      if (newVal) {
        this.submitLoading = false
      }
    }
  },
  methods: {
    confirm() {
      this.submitLoading = true
      this.confirmFunction()
      this.$emit('update:show', false)
    },
    cancel() {
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.air-modal {
  .air-modal-body {
    min-height: 132px;

    img {
      width: 40px;
      height: 40px;
      margin-top: 17px;
      margin-bottom: 16px;
    }
    .confirm-content {
      width: 372px;
      max-height: 350px;
      padding: 0 10px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 20px;
      text-align: center;
      white-space: pre-wrap;
      word-break: break-all;
      overflow-y: auto;
    }
  }
}
</style>
